import { render } from "./RowdySheeterStatistics.vue?vue&type=template&id=d9b251f4&scoped=true"
import script from "./RowdySheeterStatistics.vue?vue&type=script&lang=js"
export * from "./RowdySheeterStatistics.vue?vue&type=script&lang=js"

import "./RowdySheeterStatistics.vue?vue&type=style&index=0&id=d9b251f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b251f4"]])

export default __exports__